import '@/polyfills';
import Notifications from '@/components/framework/NotificationPlugin';
import VeeValidate from 'vee-validate';
import GlobalComponents from './globalComponents';
import GlobalDirectives from './globalDirectives';
import SideBar from '@/components/framework/SidebarPlugin';

// element ui language configuration
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);

// asset imports
import '@/assets/sass/argon.scss';
import '@/assets/css/nucleo/css/nucleo.css';
import '@/assets/css/adminlte/css/adminlte.css';
import '@/assets/css/adminlte/css/adminlte.min.css';
import '@/assets/css/adminlte/css/alt/adminlte.components.css';
import '@/assets/css/adminlte/css/alt/adminlte.components.min.css';
import '@/assets/css/adminlte/css/alt/adminlte.core.css';
import '@/assets/css/adminlte/css/alt/adminlte.core.min.css';
import '@/assets/css/adminlte/css/alt/adminlte.extra-components.css';
import '@/assets/css/adminlte/css/alt/adminlte.extra-components.min.css';
import '@/assets/css/adminlte/css/alt/adminlte.pages.css';
import '@/assets/css/adminlte/css/alt/adminlte.pages.min.css';
import '@/assets/css/adminlte/css/alt/adminlte.plugins.css';
import '@/assets/css/adminlte/css/alt/adminlte.plugins.min.css';



export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(VeeValidate, {
      fieldsBagName: 'veeFields',
      classes: true,
      validity: true,
      classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
      }
    });
  }
};
